<template>
  <v-card class="dashboard-item" :class="{'limit-dimensions': insideFeatured}" @click="goTo()">
    <v-img
      v-if="image"
      :src="image"
      aspect-ratio="2.57"
      class="flex-none"
    >
      <div class="image-overlay"></div>
      <div v-if="reservationMethod" class="img-text H8">{{ reservationMethod }}</div>
    </v-img>
    <v-card-text class="d-flex align-start justify-center flex-column">
      <div class="text-color__dark" :class="insideFeatured ? 'H4 one-line' : 'H2'">{{ title }}</div>
      <div v-if="shortDescription && !insideFeatured" class="body-cards__A description">{{ shortDescription }}</div>
    </v-card-text>
  </v-card>
</template>
  
<script>
import router from '@/router'
import routeNames from '@/router/routes'
import { getTextValue } from '@/lib/helpers/LocalizedText'
import { mapGetters } from 'vuex'
import { pageTypes, preconfiguredPageRoutes, reservationTypes } from '@/config'
  
export default {
  props: {
    page: Object,
    preconfiguredPage: Object,
    insideFeatured: Boolean,
  },
  computed: {
    ...mapGetters({ 
      authStatus: 'auth/authStatus',
      authToken: 'auth/authToken',
    }),
    image () {
      let image = null
      if (this.page) {
        image = this.page.coverImageUrl
      } else if (this.preconfiguredPage) {
        image = this.preconfiguredPage.coverImageUrl
      }
      return image
    },
    title () {
      let title = null
      if (this.page) {
        switch (this.page.type) {
        case pageTypes.LINK:
          title = getTextValue(this.page.pageSpecific.button.title)
          break
        case pageTypes.SERVICE:
          title = getTextValue(this.page.pageSpecific.title)
          break
        case pageTypes.CONTENT:
          title = getTextValue(this.page.pageSpecific.title)
          break
        case pageTypes.NAVIGATION:
          title = getTextValue(this.page.pageSpecific.title)
          break
        default:
          break
        }
      } else if (this.preconfiguredPage) {
        title = getTextValue(this.preconfiguredPage.title)
      }
      return title
    },
    shortDescription () {
      let description = null
      if (this.page && this.page.pageSpecific.shortDescription && this.page.pageSpecific.shortDescription.length > 0) {
        description = getTextValue(this.page.pageSpecific.shortDescription)
      }
      return description
    },
    authenticated () {
      let authenticated = false
      if (this.page) {
        switch (this.page.type) {
        case pageTypes.LINK:
          authenticated = this.page.pageSpecific.button.authenticated
          break
        default:
          break
        }
      }
      return authenticated
    },
    url () {
      let url = null
      if (this.page) {
        switch (this.page.type) {
        case pageTypes.LINK:
          url = this.page.pageSpecific.button.url
          break
        default:
          break
        }
      } else if (this.preconfiguredPage) {
        url = preconfiguredPageRoutes[this.preconfiguredPage.pageName]
      }
      return url
    },
    reservationMethod () {
      if (!this.page || !this.page.pageSpecific.reservationMethods) return null
      const activeReservationMethods = this.page.pageSpecific.reservationMethods.filter(({ active }) => active)
      const typesOfReservationMethods = activeReservationMethods.map(({ type }) => type)
      if (typesOfReservationMethods.includes(reservationTypes.IN_VENUE)) {
        return this.$t('pages.reservation_type.in_venue_required')
      }
      if (typesOfReservationMethods.includes(reservationTypes.ROOM_SERVICE)) {
        return this.$t('pages.reservation_type.room_service')
      }
      const externalReservation = activeReservationMethods.find(({ externalReservationSystemUrl }) => !!externalReservationSystemUrl)
      return externalReservation ? externalReservation.callToAction : null
    },
  },
  methods: {
    goTo () {
      if (!this.url) {
        this.$store.commit('pages/setPage', this.page)
        router.push({ name: routeNames.page_details.name, params: { pageId: this.page.id }})
        return
      } else {
        if (this.url.startsWith('http')) {
          if (this.authenticated && !this.authStatus) {
            router.push({ name:'login', query: { ['next-url']: this.url }})
          } else {
            if (this.url && this.authenticated) {
              const url = `${ this.url }?x-api-key=${ this.authToken }`
              window.open(url, '_blank')
            } else {
              window.open(this.url, '_blank')
            }
          }
        } else {
          if (!!routeNames[this.url]) {
            router.push({ name: this.url })
          } else {
            router.push({ path: this.url })
          }
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-item {
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--v-custom-grey-lighten1);
  box-shadow: 0px 0px 28px 0px rgba(0, 0, 0, 0.10) !important;
  height: 100%;
  .one-line {
    max-width: calc(100%);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .description {
    margin-top: 5px;
  }
  .v-image {
    position: relative;
  }
  .image-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    border-radius: 10px 10px 0px 0px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.60) 8.09%, rgba(0, 0, 0, 0.00) 38.73%, rgba(0, 0, 0, 0.00) 59.79%, rgba(0, 0, 0, 0.60) 100%);

  }
  .img-text {
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px 16px;
    color: white;
  }
  .icon-container {
    background-color: rgba(var(--v-primary-lighten1-rgb), 0.1);
  }
  .v-card__text {
    padding: 20px;
    vertical-align: middle;
  }
}
.dashboard-item.limit-dimensions {
  width: 210px;
  height: 173px;
  .image-overlay, .v-image {
    height: 123px;
  }
  .v-card__text {
    padding: 15px;
  }
}
</style>
  